import { EFieldsStateActionTypes } from './types';
import { IFieldsState } from '../../types/fieldsState';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setFieldsState = actionGenerator<EFieldsStateActionTypes.SetFieldsState, Partial<IFieldsState>>(
  EFieldsStateActionTypes.SetFieldsState,
);
